<div class="contact-picker-container" style="padding: 16px; height: 80vh; display: flex; flex-direction: column;">
  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h4 style="color: #2c3e50; margin: 0;">Kontakte auswählen</h4>
    <button type="button" (click)="cancel()" style="background: none; border: none; color: #2c3e50; font-size: 24px; cursor: pointer;">&times;</button>
  </div>

  <!-- Search and Filter -->
  <div class="row mb-3">
    <div class="col-8">
      <div class="form-group">
        <label style="color: #2c3e50; font-weight: bold;">Kontakte suchen</label>
        <input type="text" 
               class="form-control" 
               [value]="searchTerm" 
               (input)="onSearchInput($event)" 
               placeholder="Name oder E-Mail eingeben"
               style="border: 1px solid #2c3e50; border-radius: 4px; padding: 8px;">
      </div>
    </div>
    <div class="col-4">
      <div class="form-group">
        <label style="color: #2c3e50; font-weight: bold;">Filter</label>
        <select class="form-control" 
                [value]="selectedFilter" 
                (change)="onFilterChange($event)"
                style="border: 1px solid #2c3e50; border-radius: 4px; padding: 8px;">
          <option value="all">Alle Kontakte</option>
          <option value="recent">Zuletzt verwendet</option>
          <option value="favorites">Favoriten</option>
        </select>
      </div>
    </div>
  </div>

  <!-- Selected Contacts -->
  <div *ngIf="selectedContacts.length > 0" class="mb-3">
    <h6 style="color: #2c3e50;">Ausgewählte Kontakte:</h6>
    <div class="d-flex flex-wrap gap-2">
      <span *ngFor="let contact of selectedContacts; let i = index" 
            class="badge" 
            style="background-color: #2c3e50; color: white; padding: 8px 12px; border-radius: 16px; display: flex; align-items: center; gap: 8px;">
        {{contact.name}} ({{contact.email}})
        <button type="button" 
                (click)="removeSelectedContact(i)" 
                style="background: none; border: none; color: white; cursor: pointer; padding: 0; font-size: 16px; line-height: 1;">&times;</button>
      </span>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="text-center py-4">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Lade Kontakte...</span>
    </div>
    <p class="mt-2" style="color: #2c3e50;">Lade Kontakte...</p>
  </div>

  <!-- Debug Info -->
  <div class="alert alert-info" role="alert">
    <strong>Debug:</strong> Loading: {{loading}}, Error: {{error}}, Contacts: {{contacts.length}}, Filtered: {{filteredContacts.length}}
  </div>

  <!-- Error State -->
  <div *ngIf="error && !loading" class="alert alert-danger" role="alert">
    <strong>Fehler:</strong> {{error}}
  </div>


  <!-- Contacts List with Pagination -->
  <div *ngIf="!loading && !error" class="flex-1" style="display: flex; flex-direction: column; min-height: 0;">
    <!-- Pagination Info -->
    <div class="d-flex justify-content-between align-items-center mb-2">
      <small style="color: #666;">
        Zeige {{ (currentPage - 1) * pageSize + 1 }} - {{ Math.min(currentPage * pageSize, filteredContacts.length) }} von {{ filteredContacts.length }} Kontakten
      </small>
      <div class="d-flex align-items-center gap-2">
        <label style="color: #666; font-size: 12px;">Pro Seite:</label>
        <select [(ngModel)]="pageSize" (change)="onPageSizeChange()" 
                style="border: 1px solid #2c3e50; border-radius: 4px; padding: 4px 8px; font-size: 12px;">
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
      </div>
    </div>

    <!-- Contacts List -->
    <div class="flex-1" style="overflow-y: auto; border: 1px solid #ddd; border-radius: 4px; min-height: 300px;">
      <div class="list-group list-group-flush">
        <div *ngFor="let contact of getPaginatedContacts(); let i = index" 
             class="list-group-item d-flex justify-content-between align-items-center"
             [style.background-color]="isContactSelected(contact) ? '#e3f2fd' : ''"
             style="cursor: pointer; border-bottom: 1px solid #eee;"
             (click)="toggleContactSelection(contact)">
          
          <div class="d-flex align-items-center">
            <div class="me-3">
              <input type="checkbox" 
                     [checked]="isContactSelected(contact)"
                     (change)="toggleContactSelection(contact); $event.stopPropagation();"
                     style="margin: 0;">
            </div>
            <div>
              <div style="font-weight: 500; color: #2c3e50;">{{ contact.name }}</div>
              <div style="font-size: 12px; color: #666;">{{ contact.email }}</div>
              <div style="font-size: 11px; color: #999;">ID: {{ contact.id }}</div>
            </div>
          </div>
          
          <div class="d-flex align-items-center gap-2">
            <span *ngIf="contact.isFavorite" class="badge" style="background-color: #f39c12; color: white; font-size: 10px;">
              ★ Favorit
            </span>
            <button type="button" 
                    class="btn btn-sm" 
                    [style.background-color]="isContactSelected(contact) ? '#dc3545' : '#2c3e50'"
                    [style.color]="'white'"
                    (click)="toggleContactSelection(contact); $event.stopPropagation();" 
                    [title]="isContactSelected(contact) ? 'Entfernen' : 'Hinzufügen'">
              {{ isContactSelected(contact) ? '−' : '+' }}
            </button>
          </div>
        </div>
        
        <div *ngIf="getPaginatedContacts().length === 0" class="list-group-item text-center py-4" style="color: #6c757d;">
          Keine Kontakte gefunden ({{contacts.length}} Kontakte geladen)
        </div>
      </div>
    </div>

    <!-- Pagination Controls -->
    <div class="d-flex justify-content-center align-items-center mt-3 gap-2">
      <button type="button" 
              class="btn btn-sm btn-outline-secondary"
              [disabled]="currentPage === 1"
              (click)="goToPage(1)"
              title="Erste Seite">
        ««
      </button>
      <button type="button" 
              class="btn btn-sm btn-outline-secondary"
              [disabled]="currentPage === 1"
              (click)="goToPage(currentPage - 1)"
              title="Vorherige Seite">
        «
      </button>
      
      <span class="mx-3" style="color: #666;">
        Seite {{ currentPage }} von {{ getTotalPages() }}
      </span>
      
      <button type="button" 
              class="btn btn-sm btn-outline-secondary"
              [disabled]="currentPage === getTotalPages()"
              (click)="goToPage(currentPage + 1)"
              title="Nächste Seite">
        »
      </button>
      <button type="button" 
              class="btn btn-sm btn-outline-secondary"
              [disabled]="currentPage === getTotalPages()"
              (click)="goToPage(getTotalPages())"
              title="Letzte Seite">
        »»
      </button>
    </div>
  </div>

  <!-- Footer -->
  <div class="d-flex justify-content-end gap-2 mt-3">
    <button type="button" class="btn btn-secondary" (click)="cancel()">Abbrechen</button>
    <button type="button" 
            class="btn" 
            [disabled]="selectedContacts.length === 0"
            (click)="confirmSelection()"
            style="background-color: #2c3e50; color: white; border: 1px solid #34495e;">
      {{ selectedContacts.length }} Kontakt{{ selectedContacts.length !== 1 ? 'e' : '' }} auswählen
    </button>
  </div>
</div>
